<template>
  <div class="venueAppointment">
    <venueAppointmentTopbar
      v-model="currentCourseIndex"
      :statusList="statusList"
      @currentContentIndex="currentContentIndex"
      @searchVenueName="searchVenueName"
      :deleteList="deleteList"
      @delete="multipleDeleteList"
      @isAddvenueAppointmentShowSwitch="isAddvenueAppointmentShowSwitch"
    />
    <div class="venueAppointment-main">
      <venueAppointmentContentItem
        v-for="(item, index) in statusList"
        :key="index"
        :isCurrentContentItem="currentCourseIndex == index"
        :currentStatus="statusList[currentCourseIndex].value"
        :changeStatus="changeStatus"
        :searchVenueNameContent="searchVenueNameContent"
        @revocation="revocation"
        @multipleDelete="multipleDelete"
        :deleteList="venueDeleteList"
        :publicvenueList="publicvenueList"
      />
    </div>
    <venueAppointmentAdd
      :dialogFormVisible.sync="isAddvenueAppointmentShow"
      v-show="isAddvenueAppointmentShow"
      @addVenue="addVenue"
      :publicvenueList="publicvenueList"
    />
  </div>
</template>
  
  <script>
import venueAppointmentTopbar from "./components/venueAppointment-topbar/venueAppointment-topbar.vue";
import venueAppointmentContentItem from "./components/venueAppointment-content-item/venueAppointment-content-item.vue";
import venueAppointmentAdd from "./components/venueAppointment-add/venueAppointmentAdd.vue";

export default {
  data() {
    return {
      currentCourseIndex: 0,
      changeStatus: 0,
      searchVenueNameContent: "",
      statusList: [
        {
          label: "待审批",
          value: 0,
        },
        {
          label: "审批通过",
          value: 1,
        },
        {
          label: "审批拒绝",
          value: 2,
        },
        {
          label: "已撤回",
          value: 3,
        },
      ],
      venueAppointmentDetail: {},
      detailShow: false,
      deleteList: [],
      venueDeleteList: [],
      isAddvenueAppointmentShow: false,
      publicvenueList: [],
    };
  },
  components: {
    venueAppointmentTopbar,
    venueAppointmentContentItem,
    venueAppointmentAdd,
  },
  created() {
  },
  methods: {
    isAddvenueAppointmentShowSwitch(e) {
      this.getPublicvenueList();
    },
    revocation(e) {
      this.changeStatus = e;
    },
    // 搜索词(接受topbar传来的值)
    searchVenueName(e) {
      // console.log("父亲==>", e);
      // 搜索词改变时才赋值
      if (this.searchVenueNameContent != e) {
        this.searchVenueNameContent = e;
        // console.log("父亲==>",this.searchContent);
      }
    },
    // 当前选中状态下标
    currentContentIndex(e) {
      this.currentCourseIndex = e;
    },
    multipleDelete(list) {
      this.deleteList = list;
    },
    multipleDeleteList(list) {
      this.venueDeleteList = list;
    },
    addVenue(e) {
      this.changeStatus = e;
    },
    getPublicvenueList() {
      this.get(
        this.$url.getPublicvenueList + "?schoolId=" + this.user.schoolId
      ).then((res) => {
        // console.log("场馆列表==>", res);
        this.publicvenueList = res.rows;
        this.isAddvenueAppointmentShow = true;
      });
    },
  },
};
</script>
  
  <style scoped lang="scss">
@import "./venueAppointment.scss";
</style>